import { FC } from "react";
import useCreate from "./hook";
import { Styles } from "./styled";
import CreatePage from "@lhd/components/CloneApp/pages/CreatePage";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";
import { ROUTES } from "@lhd/constants";

const CreateLayout = (props: ReturnType<typeof useCreate>) => {
  return (
    <Styles>
      <CreatePage
        appType={APP_TYPES.FINANCIAL_REPORTS}
        url={`/${ROUTES.FINANCIAL_REPORTS}`}
      />
    </Styles>
  );
};

const Create: FC = () => <CreateLayout {...useCreate()} />;

export default Create;
